module.exports = __webpack_public_path__ + "img/high-you-icon1.a9a38045.png";